export default {
  dashboard: '/',
  login: '/login',
  user: {
    list: '/user',
    base: '/user',
    create: '/user/create',
    edit: '/user/edit/:key',
    editWithKey: '/user/edit'
  },
  organization: {
    list: '/organization',
    base: '/organization',
    create: '/organization/create',
    edit: '/organization/edit/:key',
    editWithKey: '/organization/edit',
    rule: '/organization/rule/:key',
    ruleWithKey: '/organization/rule',
    packageInfo: '/organization/package-info/:key',
    packageInfoWithKey: '/organization/package-info'
  },
  license: {
    base: '/license',
    list: '/license'
  },
  languageLocale: {
    list: '/language-locale',
    base: '/language-locale',
    create: '/language-locale/create',
    edit: '/language-locale/edit/:key',
    editWithKey: '/language-locale/edit'
  },
  qa: {
    list: '/qa',
    base: '/qa',
    create: '/qa/create',
    edit: '/qa/edit/:key',
    editWithKey: '/qa/edit'
  },
  hook: '/hook'
}



// WEBPACK FOOTER //
// ./src/constants/slug.js